export default __webpack_public_path__ + "static/media/cut.0de29a99.svg";